import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {MedicalRecordVisitReasonLabelModel} from '../model/medicalRecordVisitReasonLabel.model';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class MedicalRecordVisitReasonLabelConverter extends HttpModelConverter<MedicalRecordVisitReasonLabelModel> {
    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): MedicalRecordVisitReasonLabelModel {
        return new MedicalRecordVisitReasonLabelModel();
    }

    protected enrichObject(result: MedicalRecordVisitReasonLabelModel, src: MedicalRecordVisitReasonLabelModel) {
        result.lovValue = this.lovValueSummaryConverter.convert(src.lovValue);
    }
}
